import React, { FC } from 'react'
import Paper from '@mui/material/Paper'
import Link from '@mui/material/Link'
import { DataGridPremium, GridColDef } from '@mui/x-data-grid-premium'
import format from 'date-fns/format'
import { Gateway } from 'src/api'
import { TableToolbar } from 'src/components/ui'

interface Reading {
  name: string
  value: string
  link?: string
}

const columns: GridColDef<Reading>[] = [
  { field: 'name', headerName: 'Reading', flex: 1, sortable: false, disableColumnMenu: true },
  {
    field: 'value',
    headerName: 'Value',
    flex: 1,
    sortable: false,
    disableColumnMenu: true,
    renderCell: ({ row }) =>
      row.link ? (
        <Link href={row.link} target="_blank" rel="noopener noreferrer">
          {row.value}
        </Link>
      ) : (
        row.value || '-'
      )
  }
]

interface GatewayLastReadingsProps {
  gateway: Gateway
}

export const GatewayLastReadings: FC<GatewayLastReadingsProps> = ({ gateway }) => {
  if (!gateway) return null

  const { currentData } = gateway
  const { latitude, longitude, lastPingAt } = currentData || {}
  const hasLocation = latitude != null && longitude != null

  const data: Reading[] = [
    {
      name: 'Location',
      value: hasLocation ? `${latitude}, ${longitude}` : '',
      link: hasLocation ? `https://www.google.com/maps?q=${latitude},${longitude}` : undefined
    },
    {
      name: 'Last Ping At',
      value: lastPingAt ? format(new Date(lastPingAt), 'PP p') : ''
    }
  ]

  return (
    <Paper sx={{ height: '300px' }}>
      <DataGridPremium<Reading>
        pagination={false}
        autoHeight={false}
        disableRowSelectionOnClick
        rows={data}
        columns={columns}
        rowCount={data.length}
        getRowId={(row) => row.name}
        rowThreshold={2}
        columnThreshold={2}
        hideFooterPagination
        localeText={{
          columnMenuSortAsc: 'Sort A-Z',
          columnMenuSortDesc: 'Sort Z-A'
        }}
        slots={{
          toolbar: () => <TableToolbar exportedFileName={`${document.title}_gateway_last_readings`} />
        }}
        sx={{
          border: 'none',
          '& .MuiDataGrid-columnHeaderTitleContainerContent': {
            paddingLeft: '5px',
            overflow: 'visible'
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            whiteSpace: 'normal',
            lineHeight: 1,
            fontSize: '13px',
            fontWeight: 400,
            color: 'rgba(0, 0, 0, 0.6)',
            overflow: 'visible'
          }
        }}
      />
    </Paper>
  )
}
